import styled from 'styled-components';



export const CookiesWrapper = styled.div`
    position: fixed;
    background-color: #fff;
    width: 100%;
    bottom: 0;
    padding: 10px 20px;
    z-index: 200;
    color: #000;
    box-shadow: 0px 8px 13px #ccc;

    p {
        font-size: 14px;
        line-height: 1.6; 
    }

    .container {
        max-width: 120rem;
        width: 120rem; 
        margin: 0 auto;
    }

    @media only screen and (max-width: 64em) {
        .container {
            max-width: 95vw;
            width: 95vw; 
        } 
    }
    .flex-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap; 
    }


 .buttons-cols {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: flex-end; 
}
   .btn_cookie {
   width: 60% !important;
   margin: 5px 0.5em !important;
  }


  &.cookies.expanded .tabs button {
    background: white !important;
    outline: none !important;
    cursor: pointer;
    font-size: 15px;
    color: #000000;
    padding: 1.5%;
    flex: 0 0 50%;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: normal;
    justify-content: center;
}
    .cols {
        width: 65%; 

        button {
            width: fit-content;
            display: flex;
            align-items: center;
            padding: 10px;
            color: white;
            background: linear-gradient(to right, #654AD2 0%, #2173CF 40%, #247CCC 49%, #36B1BD 100%, #654AD2 0%, #2173CF 40%, #247CCC 49%, #36B1BD 100%);
            background-size: 150%;
            border: none;
            border-radius: 2px;
            font-size: 2.4rem;
            font-weight: 900;
            letter-spacing: .05rem;
            transition: all .5s ease;
        }
    }

    @media only screen and (max-width: 37.5em) {
        .cols {
            width: 100%; 
        } 
    }

    .cols:last-child {
        display: inline-flex;
        justify-content: center;
        width: 35%;
        flex-wrap: wrap; 
    }
    
    @media only screen and (max-width: 37.5em) {
        .cols:last-child {
          width: 100%; 
        } 
    
    }
    .cols .main__btn {
        font-size: 14px;
        display: inline-block;
        margin: 10px 0.5em;
        padding: 10px 20px;
        text-align: center;
        margin-left: 0; 
    }

    @media only screen and (max-width: 64em) {
        .cols .main__btn {
            min-width: 170px; 
        }
    }
    @media only screen and (max-width: 37.5em) {
        .cols .main__btn {
            width: 100vw; 
        } 
    }

    .cols .main__btn:hover {
        cursor: pointer; 
    }

    .cols .main__btn#showmore {
        background: transparent !important;
        border: 1px solid #654AD2;
        color: #654AD2; 
    }
        .cookieSwitch-container{
    align-items: center;
    display: flex;
    padding: 5px;  
    margin-top: 1%;
  }
  .underCookieSwitchContainer{
    display: flex;
    align-items: center;
  }
  #showMoreLink{
    display: flex;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    font-size: 15px;
    margin-left: 30px;
    margin-right: 20px;
    
  }
   .p-cookie{
    display: inline-block;
    position: relative;
    font-weight: bold;
    margin:0px 5px 0px 30px;
    padding: 2px;
    color: black;
    
  } 

  .switchCookie {
    height: 30px;
    position: relative;
    display: inline-block;
    width: 60px;
    margin: 0px;
  }

  
  .switchCookie input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
 
  .sliderCookie {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .sliderCookie:before {
    position: absolute;
    content: "";
    height: 70%;
    width: 40%;
    left: 10%;
    bottom: 15%;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .checkboxSwitch:checked + .sliderCookie {
    background: linear-gradient(to right, #654ad2 0%, #2173cf 50%, #247ccc 60%, #36b1bd 80%);
  }
  .checkboxSwitchDis:disabled + .sliderCookie {
    background-color: #90c9f7 !important;
    cursor: not-allowed;
  }
  
  .checkboxSwitch:focus + .sliderCookie {
    box-shadow: 0 0 1px #2196F3;
  }
  
  .checkboxSwitchDis:checked + .sliderCookie:before {
    -webkit-transform: translateX(100%);
    -ms-transform: translateX(100%);
    transform: translateX(100%);
  }
  .checkboxSwitch:checked + .sliderCookie:before {
    -webkit-transform: translateX(100%);
    -ms-transform: translateX(100%);
    transform: translateX(100%);
  }
  

 
  .sliderCookie.round {
    border-radius: 34px;
  }
  
  .sliderCookie.round:before {
    border-radius: 50%;
  }

.tabs-container{
  display: none;
}

  &
.cookies.expanded {
    border-radius: 5px;
    width: 60%;
    background-color: white;
    border: 1px solid #ccc;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 10%;
    left: 20%;
    bottom: 5%;
    animation: popUp 0.5s;
    display: flex;
    flex-direction: column; 
    justify-content: space-between; 
    overflow: hidden; 
    z-index: 9999;
}
&.cookies.expanded .container{
  max-width: 100%;
  height: 100%;
}

@keyframes popUp {
    0% {
        transform: translateY(+200px);
    }
    100% {
        transform: translateY(0px);
    }
}
 &
.cookies.expanded .cols{
  width: 100%;
 }
&.cookies.expanded .flex-row {
    display: flex;
    flex-direction: column;
    flex: 1; 
    height: 100%;
    justify-content: space-between;
}

&.cookies.expanded .p-cookie1 {
    display: none;
}

&.cookies.expanded .p-cookie {
    display: inline-block;
    position: relative;
    font-weight: bold;
    margin: 0px 5px 0px 30px;
    padding: 2px;
}
&.cookies.expanded .p-cookie2 {
  display: inline-block;
  position: relative;
  font-weight: bold;
  margin: 0px 5px 0px 15px;
  padding: 2px;
  font-size: 16px;
}
&.cookies.expanded .cookieSwitch-container {
    display: none;
}
&.cookies.expanded .tabs-container {
    display: block;
    width: 100%; 
    overflow-y: auto; 
    flex: 1; 
}
&.cookies.expanded .tabs-container.active {
    display: block;
}
&.cookies.expanded .tabs {
    display: flex;
    justify-content: space-around;
    width: 100%;
}
    &.cookies.expanded .h4Cookie {
    font-size: 16px;
    text-align: start;
    font-weight: bold;
    color: black;
}
&.cookies.expanded .tabs button:hover {
    background-color: #ddd;
}
&.cookies.expanded .tabs button.active {
    border-bottom: 1.5px solid #5062cd !important;
    color: #5062cd;
}
  


&.cookies.expanded .tabcontent {
    display: none;
    padding: 20px;
    border-top: none;
    max-height: 450px;
   overflow-x: hidden;
   overflow-y: auto;
   scrollbar-width: thin;
   scrollbar-color: #5062cd;
}
&.cookies.expanded .tabcontent.active {
    display: block;
}
&.cookies.expanded .header-tabs {
  width: 100%;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1%;
}
&.cookies.expanded .header-tabs a {
  margin-left: auto; 
  text-decoration: none;
}
&.cookies.expanded .header-tabs img {
  margin-right: 10px; 
}&.cookies.expanded .buttons-col {
  width: 100%; 
  display: flex; 
    flex-shrink: 0; 
  justify-content: center !important;
  align-items: stretch;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  
}
&.cookies.expanded .btn_cookie {
  width: 80%;
  min-width: 100px; 
  box-sizing: border-box; 
  padding: 10px; 
  text-align: center; 
}
.hrCookie{
  margin-top: 3%;
  border: 1px solid rgba(128, 128, 128, 0.15);
}
.hrCookieSection{
  margin-top: 0px;
  margin-bottom: 0px;
  border: 1px solid rgba(128, 128, 128, 0.15);
}
.form-control{
  display: flex;
  align-items: center;
  padding: 20px 25px 20px 5px;
}
.form-control1{
  display: flex;
  align-items: center;
  padding: 20px 25px 20px 5px;
  border-left: 1px solid rgba(128, 128, 128, 0.15);
}
.form-control2 {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.containerFormControl{
   display: flex;
   border-bottom: 1px solid rgba(128, 128, 128, 0.15);
}
.containerFormControl1 {
  display: flex;
  flex-direction: column;
}
.cookie-control{
  display: flex;
  align-content: end;
  width: 70%;
  justify-content: flex-end;
}
.cookie-description {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
  margin-left: 25px; 
}


.short-text-cookie,
.full-text-cookie {
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
  letter-spacing: 0.5px;
  color: black;
}


.full-undertext-cookie{
  font-size: 12px;
}

.toggle-button-cookie {
  background: white !important;
  color: black !important;
  width: 50% !important;
  border: none;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
  display: flex;
  align-items: center;
} 
  img {
    width: 15px;
    height: 15px;
  } 
.colored{
  color: #5062cd;
}

.rotatedSvg{
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
 

.cookie-description.expanded .full-text-cookie {
  display: block;
  width: 95%;
}

.cookie-underdescription.expanded .full-undertext-cookie{
   display: block;
   width: 80%;
}
@media(max-width: 1440px){
   &.cookies.expanded .tabcontent{
     max-height: 500px;
   }
}

@media (max-width: 1024px){
&.cookies.expanded{
    max-height: none;
    z-index: 9999;
    bottom: 2%;

  }
&.cookies.expanded .tabcontent{
    max-height: 450px;

  }
&.cookies.expanded .tabs button {
     padding: 1.8%;
  }
  .toggle-button-cookie{
    width: 50% !important;
  }
&.cookies.expanded .h4Cookie,&.cookies.expanded .p-cookie2  {
    font-size: 13px;
  }
  .short-text-cookie, .full-text-cookie,&
.cookies.expanded .p-cookie  {
    font-size: 12px;
  }
}



@media (max-width: 768px){
&.cookies.expanded .buttons-col{
    flex-wrap: wrap;
    }
  &.cookies.expanded .tabcontent{
      max-height: 350px;
  }
  .cookie-description {
    margin-top: 0px;

  }
  .p-cookie, #showMoreLink{
    font-size: 12px !important;
  }
  .short-text-cookie, .full-text-cookie{
    padding: 0px 5px 0px 5px;
    font-size: 12px;
  }
&.cookies.expanded .p-cookie2{
    margin: 0%;
    margin-left: 5%;
    font-size: 14px;
  }
  .form-control1, .form-control{
    padding: 5px 10px 5px 10px;
  }
&.cookies.expanded .tabs button{
    padding: 10px;
  }
  .cookieSwitch-container{
    align-items: center;
  }
  .toggle-button-cookie{
    width: 60% !important;
  }
}


@media(max-width: 599px){
&.cookies.expanded{
  width: 90%;
  left: 5%;
}&.cookies.expanded .tabcontent{
  padding: 10px;
}
.buttons-col {
  align-items: center;
  align-content: center !important;
}&.cookies.expanded .tabs button{
  padding: 10px;
}
.btn_cookie{
  width: 80% !important;
}&.cookies.expanded .btn_cookie{
  width: 100%;
}&.cookies.expanded .buttons-col{
  align-items: center;
  flex-direction: column;
}&.cookies.expanded .p-cookie{
  margin: 0px 5px 0px 5px;
  width: 50%;
  text-align: center;
}
.cookie-control{
  align-items: center;
}
.short-text-cookie, .full-text-cookie{
  font-size: 12px;
}&.cookies.expanded .p-cookie2{
  font-size: 12px;
  margin-left: 3%;
}


.cookieSwitch-container{
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

}
.cookies .flex-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.p-cookie{
  margin: 0px 5px 0px 5px;
}
#showMoreLink{
  margin: 10px 0px 10px 0px;
}
}

@media (max-width: 410px){
  .cookieSwitch-container{
    display: flex;
    flex-direction: row;
   
    align-items: center;
    flex-wrap: wrap;
  }
  .p-cookie{
    margin: 0%;
  }
  .sliderCookie{
    margin: 3%;

  }
  .form-control, .form-control1{
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .underCookieSwitchContainer{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
    .containerFormControl1{
    align-items: center;
    }
}

`
export const PopUpWrapper = styled.div`
.popUp-cookie{
   width: 50px;
   height: 50px;
   background-color: white;
   border-radius: 50%;
   position: fixed;
   right: 80px;
   bottom: 20px;
   z-index: 9999;
   animation: popUpIncoming 0.5s ease-in-out;
}
    .popUp-cookie-button{
       width: 100%;
       height: 100%;
       border-radius: 50%;
       display: flex;
       justify-content: center;
       align-items: center;
    }
  .popUp-cookie:hover{
       box-shadow: 0 12px 16px 0 rgba(0,0,0,0.35),0 17px 50px 0 rgba(0,0,0,0.19);
      }

@keyframes popUpIncoming {
    0% {
        transform: translateX(100px);
        opacity: 0;
    }
    100% {
        transform: translateìX(0px);
        opacity: 1;
    }
}

.tooltiptext {
  visibility: hidden; 
  width: 120px;
  height: 30px; 
  background-color: black; 
  color: #fff !important; 
  text-align: center; 
  border-radius: 25px; 
  padding: 5px;
  position: absolute; 
  z-index: 1; 
  top: 50%;
  right: 130%;
  margin-left: -100px; 
  opacity: 0; 
  transition: opacity 0.3s; 
  transform: translateY(-50%);
}
.popUp-cookie-button:hover .tooltiptext {
  visibility: visible; 
  opacity: 1; 

}
  .cookieIcon{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

@media (max-width: 599px){
   .popUp-cookie{
   position: fixed;
   right: 20px;
   bottom: 80px;
  }
   .cookieIcon{
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
}
`